import { useAppContext } from '../../appProvider/contextProvider';
import Bell from '../../assets/images/bell.svg';

const SlideDown = ({
    title,
    titleColor,
    message,
    messageColor,
    allowBtnText,
    allowBtnTextColor,
    allowBtnColor,
    denyBtnText,
    denyBtnTextColor,
    denyBtnColor,
    background,
    iconPath
}) => {

    const {selectedWebsite} = useAppContext();

    return <div className="prompt-alert" data-alert="slide-down" style={{background: background}}>
    <div className="media">
        <div className="media__figure">
            <img src={iconPath || Bell} alt="Bell"/>                                                            
        </div>
        <div className="media_body">
            <div className="custom-description">
                <h6 className="break-heading" style={{color: titleColor}} >{title}</h6>
                <p className="mb-2" style={{color: messageColor}}>{message}</p>
            </div>
        </div>                                                            
    </div>     
                                                      
    <div className="d-flex justify-content-between align-items-end mt-1">
    {selectedWebsite?.is_branding_enabled && <p className="mb-0"><small className="text-light">Powered by ChirpyWeb</small></p>  }
        <div className="d-flex float-right ml-auto">
            <button 
                className="btn btn-outline btn-blocked mr-2"
                style={{background: denyBtnColor, color: denyBtnTextColor}}    
            >{denyBtnText}</button>
            <button 
                className="btn btn-outline btn-allow"
                style={{background: allowBtnColor, color: allowBtnTextColor}}
            >{allowBtnText}</button>
        </div>
    </div>                                                        
</div>
}


export default SlideDown;